module.exports = __webpack_public_path__ + "img/w59.84fd30e3.svg";